import { createAction } from '@reduxjs/toolkit'
import { AssignItem, AssignProject } from '../models/Review'
import { Organization } from '../models/Organization'

export const setAssignedItems = createAction<AssignItem[]>(
  'review/setAssignedItems',
)
export const setAssignedProjects = createAction<AssignProject[]>(
  'review/setAssignedProjects',
)
export const assignItem = createAction<AssignItem>('review/assignItem')
export const updateAssignedProject = createAction<AssignProject>(
  'review/updateAssignedProject',
)
export const setSelectedProject = createAction<number | undefined>(
  'review/setSelectedProject',
)
export const setEngineerOrganization = createAction<Organization>(
  'review/setEngineerOrganization',
)
